"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Step5 = void 0;
var React = require("react");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var userLens_1 = require("@caddigital/sok-reducers/lib/utils/userLens");
var sok_ui_1 = require("@caddigital/sok-ui");
var getProjectAdmins = function (userGroups) {
    if (typeof userGroups !== 'undefined') {
        var emails = userGroups.reduce(function (arr, category) {
            var adminGroup = userGroups.find(function (category) { return category.category.type === 'ProjectAdminUserGroup'; });
            if (adminGroup) {
                adminGroup.groups.map(function (userGroup) {
                    return userGroup.members &&
                        userGroup.members.map(function (user) { return arr.push(user.email); });
                });
            }
            if (category.category.members) {
                category.category.members.map(function (user) { return arr.push(user.email); });
            }
            return arr;
        }, []);
        if (emails.length > 0) {
            return emails.join(', ');
        }
    }
    return (0, translation_1.getLocalization)('admin/projectsTab/editProject/summary/informationMissing');
};
var Step5 = function (props) { return (React.createElement("div", { className: 'project-summary' },
    React.createElement("div", { className: 'summary-view' },
        React.createElement("div", { className: 'card-box' },
            React.createElement("h2", null,
                React.createElement(sok_ui_1.Icon, { className: 'far fa-file-alt' }),
                ' ',
                (0, translation_1.getLocalization)('admin/projectsTab/editProject/summary/summaryTitle')),
            React.createElement("div", { className: 'card-box-content' },
                React.createElement("div", { className: 'summary-text' },
                    React.createElement("div", null, (0, translation_1.getLocalization)('admin/projectsTab/editProject/summary/summaryDescription'))))),
        React.createElement("div", { className: 'card-box' },
            React.createElement("h2", null,
                React.createElement(sok_ui_1.Icon, { className: 'far fa-newspaper' }),
                ' ',
                (0, translation_1.getLocalization)('admin/projectsTab/editProject/summary/basicInformationTitle')),
            React.createElement("div", { className: 'card-box-content' },
                React.createElement("div", { className: 'summary-info' },
                    React.createElement("div", { className: 'summary-info-content' },
                        React.createElement(sok_ui_1.Grid.Row, null,
                            React.createElement(sok_ui_1.Grid.Column, { medium: 6 },
                                React.createElement("b", null,
                                    (0, translation_1.getLocalization)('admin/projectsTab/editProject/summary/companyName'),
                                    ":"),
                                props.step1.customer !== null
                                    ? props.step1.customer.name
                                    : ''),
                            React.createElement(sok_ui_1.Grid.Column, { medium: 6 },
                                React.createElement("b", null,
                                    (0, translation_1.getLocalization)('admin/projectsTab/editProject/summary/projectAdmins'),
                                    ":"),
                                getProjectAdmins(props.wizard.step3.groups))),
                        React.createElement(sok_ui_1.Grid.Row, null,
                            React.createElement(sok_ui_1.Grid.Column, { medium: 6 },
                                React.createElement("b", null,
                                    (0, translation_1.getLocalization)('admin/projectsTab/editProject/summary/projectName'),
                                    ":"),
                                props.step1.projectName),
                            React.createElement(sok_ui_1.Grid.Column, { medium: 6 },
                                React.createElement("b", null,
                                    (0, translation_1.getLocalization)('admin/projectsTab/editProject/summary/customerSalesRepresentative'),
                                    ":"),
                                props.step1.customerSalesRepresentative
                                    ? userLens_1.getName.get(props.step1.customerSalesRepresentative)
                                    : (0, translation_1.getLocalization)('admin/projectsTab/editProject/summary/informationMissing'))),
                        React.createElement(sok_ui_1.Grid.Row, null,
                            React.createElement(sok_ui_1.Grid.Column, { medium: 6 },
                                React.createElement("b", null,
                                    (0, translation_1.getLocalization)('admin/projectsTab/editProject/summary/projectSalesRepresentative'),
                                    ":"),
                                props.step1.salesRepresentive
                                    ? userLens_1.getName.get(props.step1.salesRepresentive)
                                    : (0, translation_1.getLocalization)('admin/projectsTab/editProject/summary/informationMissing')),
                            React.createElement(sok_ui_1.Grid.Column, { medium: 6 },
                                React.createElement("b", null,
                                    (0, translation_1.getLocalization)('admin/projectsTab/editProject/summary/notifyFollowingRecipients'),
                                    ":"),
                                props.step1.notifyFollowing.length > 0
                                    ? props.step1.notifyFollowing.join('; ')
                                    : (0, translation_1.getLocalization)('admin/projectsTab/editProject/summary/informationMissing'))),
                        React.createElement(sok_ui_1.Grid.Row, null,
                            React.createElement(sok_ui_1.Grid.Column, { medium: 6 },
                                React.createElement("b", null,
                                    (0, translation_1.getLocalization)('admin/projectsTab/editProject/summary/printProvider'),
                                    ":"),
                                props.step1.selectedPrintProvider &&
                                    props.step1.selectedPrintProvider.name
                                    ? props.step1.selectedPrintProvider.name
                                    : (0, translation_1.getLocalization)('admin/projectsTab/editProject/summary/informationMissing')),
                            React.createElement(sok_ui_1.Grid.Column, { medium: 6 },
                                React.createElement("b", null,
                                    (0, translation_1.getLocalization)('admin/projectsTab/editProject/summary/projectCreatedBy'),
                                    ":"),
                                props.step1.author
                                    ? userLens_1.getName.get(props.step1.author)
                                    : (0, translation_1.getLocalization)('admin/projectsTab/editProject/summary/informationMissing'))),
                        React.createElement(sok_ui_1.Grid.Row, null,
                            React.createElement(sok_ui_1.Grid.Column, { medium: 6 },
                                React.createElement("b", null,
                                    (0, translation_1.getLocalization)('admin/projectsTab/editProject/summary/billingInformation'),
                                    ":"),
                                props.step1.billingInformations &&
                                    props.step1.billingInformations.length > 0
                                    ? props.step1.billingInformations
                                        .map(function (value) {
                                        if (value.type === 'CUSTOM') {
                                            return value.customerName;
                                        }
                                        var customerText = [
                                            "".concat(value.customerName, " (").concat(value.customerNumber, ")")
                                        ];
                                        var projectTexts = value.projects
                                            ? value.projects.map(function (x) { return "".concat(x.projectName, " (").concat(x.projectNumber, ")"); })
                                            : [];
                                        return customerText.concat(projectTexts).join(', ');
                                    })
                                        .join(', ')
                                    : (0, translation_1.getLocalization)('admin/projectsTab/editProject/summary/informationMissing'))),
                        React.createElement(sok_ui_1.Grid.Row, null,
                            React.createElement(sok_ui_1.Grid.Column, { medium: 6 },
                                React.createElement("b", null,
                                    (0, translation_1.getLocalization)('admin/projectsTab/editProject/summary/description'),
                                    ":"),
                                props.step1.description.length > 0
                                    ? props.step1.description
                                    : (0, translation_1.getLocalization)('admin/projectsTab/editProject/summary/informationMissing'))))))),
        React.createElement("div", { className: 'card-box' },
            React.createElement("h2", null,
                React.createElement(sok_ui_1.Icon, { className: 'far fa-sitemap' }),
                ' ',
                (0, translation_1.getLocalization)('admin/projectsTab/editProject/summary/addOnsTitle')),
            React.createElement("div", { className: 'card-box-content' },
                React.createElement("div", null, (0, translation_1.getLocalization)('admin/projectsTab/editProject/summary/addOnsDescription')),
                React.createElement("div", { className: 'feature-list' }, props.step1.features
                    .filter(function (x) { return x.enabled; })
                    .map(function (x) { return (React.createElement("div", null,
                    "- ",
                    React.createElement("b", null, (0, translation_1.getLocalization)('features/' + x.constant + '/name')),
                    ' ',
                    React.createElement("i", null,
                        "(",
                        x.price,
                        " \u20AC)"))); }))))))); };
exports.Step5 = Step5;
